import PropTypes from 'prop-types'

/**
 * @typedef {Object} OrderContact
 * @property {string} [email]   - Email of order contact persion.
 * @property {string} [name]    - Contact name of order.
 * @property {string} [phone]   - Phone number of order contact person.
 */

export const orderContactPropType = PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string
})
